import { useLanguage } from '../contexts/LanguageContext';
import clsx from 'clsx';

export const TotalsBar = ({ collected = 0, expenses = 0, className = "" }) => {
    const { t } = useLanguage();

    const netBalance = collected - expenses;
    const isPositive = netBalance >= 0;

    const formatCurrency = (amount, sign = "") => {
        const absAmount = Math.abs(amount).toFixed(0).toLocaleString();
        if (sign === "+") return `+ ₪ ${absAmount}`;
        if (sign === "-") return `- ₪ ${absAmount}`;
        return `₪ ${absAmount}`;
    };

    return (
        <div className={clsx(
            "w-full bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-y border-poker-gold/30 py-0.5 px-2 md:px-6 shadow-xl overflow-hidden shrink-0 z-50",
            className
        )}>
            <div className="max-w-7xl mx-auto flex items-center justify-between gap-1 md:gap-8">
                {/* Collected */}
                <div className="flex items-center gap-1 md:gap-2 whitespace-nowrap min-w-0">
                    <span className="text-[7px] md:text-[10px] text-slate-500 font-black uppercase tracking-tighter md:tracking-wider shrink-0">גבייה</span>
                    <span className="text-[11px] md:text-lg font-black text-emerald-400 tabular-nums shrink-0 whitespace-nowrap" dir="ltr">
                        {formatCurrency(collected)}
                    </span>
                </div>

                {/* Divider */}
                <div className="h-3 w-px bg-white/5 flex-shrink-0"></div>

                {/* Expenses */}
                <div className="flex items-center gap-1 md:gap-2 whitespace-nowrap min-w-0">
                    <span className="text-[7px] md:text-[10px] text-slate-500 font-black uppercase tracking-tighter md:tracking-wider shrink-0">הוצאות</span>
                    <span className="text-[11px] md:text-lg font-black text-rose-500 tabular-nums shrink-0 whitespace-nowrap" dir="ltr">
                        {formatCurrency(expenses, "-")}
                    </span>
                </div>

                {/* Total Net (Highlighted) */}
                <div className={clsx(
                    "flex flex-1 items-center justify-end gap-1.5 md:gap-3 pl-1 shrink-0",
                    isPositive ? "bg-emerald-500/5" : "bg-rose-500/5"
                )}>
                    <span className="text-[7px] md:text-[10px] text-slate-400 font-black uppercase tracking-tighter md:tracking-wider shrink-0">{t('netBalance')}:</span>
                    <span className={clsx(
                        'text-[13px] md:text-xl font-black tabular-nums shrink-0 whitespace-nowrap transition-colors',
                        isPositive ? 'text-emerald-400' : 'text-rose-500'
                    )} dir="ltr">
                        {formatCurrency(netBalance, isPositive ? "+" : "-")}
                    </span>
                </div>
            </div>
        </div>
    );
};
